// src/App.js
import React from "react";
import Home from "./pages/Home";
import "./index.css";

function App() {
  return <Home />;
}

export default App;